<template>
  <div class="userWrap">
    <h4>修改手机号码</h4>

    <div class="formWrap">
      <el-form :model="resetTelForm" :rules="rules" ref="resetTelForm" label-width="0" class="resetTelForm">

        <!-- 新手机号码 -->
        <el-form-item prop="mobile" class="mobileItem">
          <p>新手机号码</p>
          <el-input v-model="resetTelForm.mobile" size="medium" autocomplete="off">
            <template slot="prepend">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  + {{ resetTelForm.gr || '?' }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="item in countryList" :key="item.country_id" @click.native="selectGr(item.country_code)">
                    +{{item.country_code}} {{item.country_name}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-input>
        </el-form-item>

        <!-- 新手机验证码 -->
        <el-form-item prop="code">
          <p>新手机验证码</p>
          <el-input v-model="resetTelForm.code" size="medium" autocomplete="off">
            <template slot="append">
              <span @click="getOPT">{{optWords}}</span>
            </template>
          </el-input>
        </el-form-item>


        <!-- 支付密码 -->
        <el-form-item prop="password">
          <p>支付密码</p>
          <el-input type="password" v-model="resetTelForm.password" size="medium" autocomplete="off"></el-input>
        </el-form-item>

        <div class="submit">
          <el-button type="primary" size="medium" @click="regForm('resetTelForm')">
            {{pc_lang.Confirm_submission}}
          </el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import * as API_USER from '@/api/user'
import { mapGetters } from 'vuex'
import * as RegExp from '@/utils/RegExp'

export default {
  name: 'UserResetTel',
  components: {

  },
  data() {
    return {
      resetTelForm: {
        mobile: '',
        code: '',
        password: '',
        gr: ''
      },
      optTimer: null,
      optBool: 1,
      optWords2: '',
    }
  },
  computed: {
    ...mapGetters([ 'countryList' ]),
    rules() {
      let validatePay = (rule, value, callback) => {
        if (value === '') {
        callback(new Error(this.pc_lang.Enter_the_password));
      } else if( !RegExp.payword.test(value) ) {
        callback(new Error(this.pc_lang.Password_consists_of_6_digits));
      }else {
        callback();
      }
      };
      let validateMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_Hp_No));
        } else if (String(value).length < 8 || String(value).length > 14) {
          callback(new Error(this.pc_lang.please_enter_a_valid_phone_number));
        } else {
          API_USER.checkMobile({mobile: value}).then(res=> {
            if (res.data) {
              callback();
            } else {
              callback(new Error(this.pc_lang.The_phone_number_has_been_registered));
            }
          },rej=> {
            callback(new Error(this.pc_lang.please_enter_a_valid_phone_number));
          })
        }
      };
      return {
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.pc_lang.Enter_verification_code, trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6个字符', trigger: 'blur' }
        ],
        password: [
          { validator: validatePay, trigger: 'blur' }
        ]
      }
    },
    // 验证码单词
    optWords: {
      get() {
        return this.optWords2 == "" ? this.pc_lang.Get_verification_code : this.optWords2
      },
      set(val) {
        this.optWords2 = val
      }
    }
  },
  async mounted() {

  },
  beforeDestroy() {
    try{
      window.clearInterval(this.optTimer)
    }catch(err){}
    this.optTimer = null
  },
  created() {

  },
  methods: {
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    /* 获取验证码 */
    getOPT() {
      if (!!!this.resetTelForm.gr) {
        this.$message_box.alert('请选择手机区号', 'Error', {
          type: 'error',
          callback: ()=> {

          }
        })
        return false
      }
      if (!!!this.resetTelForm.mobile) {
        this.$message_box.alert('请填写手机号', 'Error', {
          type: 'error',
          callback: ()=> {

          }
        })
        return false
      }
      if (!Array.from(document.querySelector('.mobileItem').classList).includes('is-error')) {
        if (this.optBool) {
          this.optBool = 0
          const { mobile, gr } = this.resetTelForm
          API_USER.verify_new_mobile( mobile, gr ).then(res=>{
            let num = res.data || 120
            let optTimer = setInterval(()=> {
              num--
              let word = this.pc_lang.Get_the_code_after_3s.replace(/3/, num)
              if (num <= 0) {
                clearInterval(optTimer)
                this.optWords = this.pc_lang.Get_verification_code
                this.optBool = 1
                return false
              }else{
                this.optWords = word
              }
            }, 1000)
          },rej=> {
            this.optBool = 1
            try{
              this.$message.error(rej.msg)
            }catch(err){}
          })
        }
      }
    },
    /* 选择手机的国家 */
    selectGr(gr) {
      this.resetTelForm.gr = gr
    },
    /* submit */
    submit() {
      let params = Object.assign({}, this.resetTelForm)
      params.password = md5(params.password)
      API_USER.resetMobile(params).then(res=> {
        this.signOut()
        this.$message_box.alert('绑定手机修改成功，请使用新手机号码登录！', 'Success', {
          type: 'success',
          callback: ()=> {

          }
        })
      },
      rej=> {
        this.$message.error(rej.msg)
      })
    },
    /* 退出登录 */
    signOut() {
      this.$store.dispatch('token', {})
      this.$store.dispatch('user', {})
      if (this.$route.name != 'Index') {
        this.$router.push({name: 'Index'})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>